import gsap from 'gsap';

export default function clearProps(tween) {
  const children = tween.getChildren();
  children.forEach(function (child) {
    // Still a timeline
    if (child.getChildren) {
      clearProps(child);
    } else {
      // we can kill this
      const targets = child.targets();
      targets.forEach(function (target) {
        if (target.nodeType) {
          gsap.set(target, { clearProps: 'all' });
        }
      });
    }
  });
}
